import { EvaluationEditor } from "./EvaluationEditor";
import { PastEvaluations } from "./PastEvaluations";
import { Column, ErrorText, LoadingIndicator } from "@/components";
import { useUserSheet } from "@/components/user-sheet/userSheetContext";

import { cn } from "@/lib/utils";

export const EvaluationsTab = ({
  candidacyId,
  isError,
  isPending,
  talentId,
}: {
  candidacyId?: string;
  isError: boolean;
  isPending: boolean;
  talentId: number;
}) => {
  /* Context */
  const { contentPaddingClassName } = useUserSheet();

  /* Render */
  const render = () => {
    if (isPending) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <LoadingIndicator variant="medium" />
        </Column>
      );
    }
    if (isError || !candidacyId) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <ErrorText errorMessage="Error retrieving candidacy evaluation." />
        </Column>
      );
    }

    return (
      <Column className={cn("gap-6 py-7", contentPaddingClassName)}>
        {/* Keyed so switching candidacies resets the editor's local draft. */}
        <EvaluationEditor candidacyId={candidacyId} key={candidacyId} />
        <PastEvaluations candidacyId={candidacyId} talentId={talentId} />
      </Column>
    );
  };

  return render();
};
